import { render } from "./InputSelect2.vue?vue&type=template&id=451db850"
import script from "./InputSelect2.vue?vue&type=script&lang=js"
export * from "./InputSelect2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__